import React from "react";
import BulkUploadConfig from "../../components/FeatureConfig/BulkUploadConfig";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as FeatureConfigBulkUploadActions from "../../store/actions/FeatureConfig";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const FeatureConfigBulkUploadDashboard = ({ getBulkUploadUrl }) => {
  return (
    <BulkUploadConfig
      instructions={instructions}
      btnDataTestID="FeatureConfigBulkUploadBtn"
      uploadUrl="/feature-config/bulk-update"
      sampleURL="/sample/bulk_upload_feature_config.csv"
      id="FeatureConfigBulkUploadModal"
      sendExtraAck={true}
      keyName="callback"
      heading="Bulk Upload Feature Config"
      getUploadUrl={getBulkUploadUrl}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getBulkUploadUrl: bindActionCreators(
      FeatureConfigBulkUploadActions.getUploadUrl,
      dispatch
    ),
  };
}

export default connect(
  null,
  mapDispatchToProps
)(FeatureConfigBulkUploadDashboard);
